import { useEffect } from "react";
import { Reveal, Eyebrow } from "@/components/Reveal";

// GotBackup/GVO "Ambassador Interest Form" (FormId 25257083) — embedded via the
// official generate_form.js script so submissions land correctly; styling is
// overridden to the MHG palette in index.css.
const GVO_FORM_DATA =
  "eyJGb3JtSWQiOjI1MjU3MDgzLCJNYWlsU2VyaWVJZCI6MjUwMDgyMDcsIk5hbWUiOiJBbWJhc3NhZG9yIEludGVyZXN0IEZvcm0iLCJTaG93Q291bnQiOjEsIlN1Ym1pc3Npb25zIjowLCJGb3JtRmllbGRzIjp7IkZpcnN0TmFtZSI6eyJ2YWx1ZSI6IkZpcnN0IE5hbWUiLCJjaGVja2VkIjoiMSIsInJlcXVpcmVkIjoiMSJ9LCJMYXN0TmFtZSI6eyJ2YWx1ZSI6Ikxhc3QgTmFtZSIsImNoZWNrZWQiOiIwIiwicmVxdWlyZWQiOiIwIn0sIkZ1bGxOYW1lIjp7InZhbHVlIjoiRnVsbCBOYW1lIiwiY2hlY2tlZCI6IjAiLCJyZXF1aXJlZCI6IjAifSwiRW1haWwiOnsidmFsdWUiOiJQbGVhc2UgZW50ZXIgeW91ciBlbWFpbCIsImNoZWNrZWQiOiIxIiwicmVxdWlyZWQiOiIxIn19LCJUaGFua3lvdVBhZ2UiOiJodHRwczpcL1wvamxkZWxhd2Rlck5MUy5nb2d2by5jb21cL2d2b3RoYW5reW91XC8iLCJTaWduZWRVcFBhZ2UiOiIiLCJJc0RvdWJsZU9wdEluIjowLCJQYXNzRm9ybURhdGEiOjAsIlRyYWNrZXJOYW1lIjoiIiwiT3B0aW5TZW5kcyI6MCwiT3B0aW5GYWlsZWQiOjAsIlN1Ym1pdFZhbHVlIjoiQ291bnQgbWUgaW4hIiwiVXNlZEluIjoiIiwiQWN0aW9uIjoiaHR0cHM6XC9cL2dvZ3ZvLmNvbVwvc3Vic2NyaWJlLnBocCIsIkNhbXBhaWduQ29kZSI6IkxKZHlHYzBqRVg2biIsIkFmZmlsaWF0ZU5hbWUiOiJqbGRlbGF3ZGVyTkxTIiwiSW1hZ2VTcmMiOiJodHRwczpcL1wvZ29ndm8uY29tXC9zaG93X2Zvcm0ucGhwP2lkPTI1MjU3MDgzJlRyYWNrUGFyYW09bmV3X2Zvcm0ifQ==";

export default function Ambassador() {
  useEffect(() => {
    const wrap = document.getElementById("ambassador-form-wrap");
    if (!wrap) return;
    const dataScript = document.createElement("script");
    dataScript.text = `var formData = '${GVO_FORM_DATA}';`;
    wrap.appendChild(dataScript);
    const genScript = document.createElement("script");
    genScript.src = "https://gogvo.com/js/generate_form.js";
    genScript.onload = () => {
      // the GVO script renders on DOMContentLoaded, which has long fired in our SPA
      document.dispatchEvent(new Event("DOMContentLoaded"));
    };
    wrap.appendChild(genScript);
    return () => {
      wrap.innerHTML = '<div id="25257083-form"></div>';
    };
  }, []);

  return (
    <div data-testid="ambassador-page">
      <section className="mx-auto max-w-2xl px-4 pb-24 pt-16 text-center sm:px-6 lg:pt-24">
        <Reveal>
          <Eyebrow className="text-center">Founding circle</Eyebrow>
          <h1
            className="mt-4 font-serif text-4xl font-bold leading-[1.15] tracking-tight text-ink sm:text-5xl lg:text-6xl"
            data-testid="ambassador-headline"
          >
            Become a Founding{" "}
            <span className="italic text-crimson">Ambassador</span>
          </h1>
          <p
            className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-cocoa sm:text-lg"
            data-testid="ambassador-intro"
          >
            We're opening MyHeartGives in just a few communities first. Be one
            of the founding Ambassadors who leads the first campaigns of giving
            in your town.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            className="mx-auto mt-12 max-w-xl rounded-3xl border border-line bg-white p-8 text-left shadow-xl sm:p-10"
            data-testid="ambassador-form-card"
          >
            <div id="ambassador-form-wrap" data-testid="ambassador-form-wrap">
              <div id="25257083-form"></div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
